import Dispatcher from '../dispatcher';
import {actions} from '../constants/product_mixed_stocks/actions';

function openAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW,
    });
}

function closeAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE,
    });
}

function openPostcodeLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_POSTCODE_LAYER,
    });
}

function closePostcodeLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_POSTCODE_LAYER,
    });
}

function openProductLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_PRODUCT_LAYER,
    });
}

function closeProductLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_PRODUCT_LAYER,
    });
}

function setQuantityAction(quantity) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_QUANTITY,
        payload: quantity
    });
}

function resetQuantityAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.RESET_QUANTITY,
    });
}

function setCartAction(cart) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_CART,
        payload: cart
    });
}

function unsetCartAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_CART,
    });
}

function setFittingOptionsAction(fittingOptions) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_FITTING_OPTIONS,
        payload: fittingOptions
    });
}

function unsetFittingOptionsAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_FITTING_OPTIONS,
    });
}

function showItemPriceDetails() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_ITEM_PRICE_DETAILS,
    });
}

function hideItemPriceDetails() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_ITEM_PRICE_DETAILS,
    });
}

function showShippingPriceDetails() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_SHIPPING_PRICE_DETAILS,
    });
}

function hideShippingPriceDetails() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_SHIPPING_PRICE_DETAILS,
    });
}

function openOrderFormLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_ORDER_FORM_LAYER,
    });
}

function closeOrderFormLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_ORDER_FORM_LAYER,
    });
}

function openOrderStatusLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_ORDER_STATUS_LAYER,
    });
}

function closeOrderStatusLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_ORDER_STATUS_LAYER,
    });
}

function setOrderAction(order) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_ORDER,
        payload: order
    });
}

function unsetOrderAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_ORDER,
    });
}

function setErrorMessageAction(errorMessage) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_ERROR_MESSAGE,
        payload: errorMessage
    });
}

function unsetErrorMessageAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_ERROR_MESSAGE,
    });
}

function setFittingPriceInDetailModeAction(fsId) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_FITTING_PRICE_IN_DETAIL_MODE,
        payload: fsId
    });
}

function unsetFittingPriceInDetailModeAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_FITTING_PRICE_IN_DETAIL_MODE,
    });
}

function setSelectedFittingOption(fsId) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_SELECTED_FITTING_OPTION,
        payload: fsId
    });
}

function unsetSelectedFittingOption() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_SELECTED_FITTING_OPTION
    });
}

function setShippingOptionsAction(shippingOptions) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_SHIPPING_OPTIONS,
        payload: shippingOptions
    });
}

function unsetShippingOptionsAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_SHIPPING_OPTIONS,
    });
}

function openShippingAddressFormLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_SHIPPING_ADDRESS_FORM_LAYER,
    });
}

function closeShippingAddressFormLayerAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_SHIPPING_ADDRESS_FORM_LAYER,
    });
}

function withoutFittingOptionAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_WITHOUT_FITTING_OPTION,
    });
}

function withFittingOptionAction() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_WITHOUT_FITTING_OPTION,
    });
}

function showNoFittingShippingAddressSummary() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_NO_FITTING_SHIPPING_ADDRESS_SUMMARY,
    });
}

function hideNoFittingShippingAddressSummary() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.HIDE_NO_FITTING_SHIPPING_ADDRESS_SUMMARY,
    });
}

function showNoFittingShippingAddressInput() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SHOW_NO_FITTING_SHIPPING_ADDRESS_INPUT,
    });
}

function setPaymentStatus(status) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_PAYMENT_STATUS,
        payload: status
    });
}

function unsetPaymentStatus() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_PAYMENT_STATUS,
    });
}

function setTimerIntervalId(intervalId) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.SET_TIMER_INTERVAL_ID,
        payload: intervalId
    });
}

function unsetTimerIntervalId() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.UNSET_TIMER_INTERVAL_ID,
    });
}

function addFittingService(payload) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.ADD_FITTING_SERVICE,
        payload: payload
    });
}

function removeFittingService(payload) {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.REMOVE_FITTING_SERVICE,
        payload: payload
    });
}

function clearFittingService() {
    Dispatcher.handleProductMixedStocksLightboxAction({
        type: actions.CLEAR_FITTING_SERVICE,
    });
}

export {
    openAction,closeAction,
    openPostcodeLayerAction, closePostcodeLayerAction,
    openProductLayerAction, closeProductLayerAction,
    setQuantityAction, resetQuantityAction,
    setCartAction, unsetCartAction,
    setFittingOptionsAction, unsetFittingOptionsAction,
    showItemPriceDetails, hideItemPriceDetails,
    showShippingPriceDetails, hideShippingPriceDetails,
    openOrderFormLayerAction, closeOrderFormLayerAction,
    openOrderStatusLayerAction, closeOrderStatusLayerAction,
    setOrderAction, unsetOrderAction,
    setErrorMessageAction, unsetErrorMessageAction,
    setFittingPriceInDetailModeAction, unsetFittingPriceInDetailModeAction,
    setSelectedFittingOption, unsetSelectedFittingOption,
    setShippingOptionsAction, unsetShippingOptionsAction,
    openShippingAddressFormLayerAction, closeShippingAddressFormLayerAction,
    withoutFittingOptionAction, withFittingOptionAction,
    showNoFittingShippingAddressSummary, hideNoFittingShippingAddressSummary,
    showNoFittingShippingAddressInput,
    setPaymentStatus, unsetPaymentStatus,
    setTimerIntervalId, unsetTimerIntervalId,
    addFittingService, removeFittingService, clearFittingService,
};
